/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

export default function TimecardSubmitIcon({
  width = 11,
  height = 11,
  color = 'white',
  className,
  style,
}) {
  return (
    <svg
      className={className}
      style={{
        width,
        height,
        flexShrink: 0,
        ...style,
      }}
      width={width}
      height={height}
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.2194 0.0659189C10.0233 -0.235539 10.8083 0.549488 10.5069 1.35337L7.29298 9.92368C6.93557 10.8768 5.54877 10.7487 5.37187 9.74634L4.69005 5.88271L0.826425 5.2009C-0.175989 5.024 -0.303996 3.63719 0.649089 3.27979L9.2194 0.0659189ZM9.57052 1.00225L1.00021 4.21611L4.86384 4.89793C5.27774 4.97097 5.6018 5.29503 5.67484 5.70893L6.35666 9.57256L9.57052 1.00225Z"
        fill={color}
      />
    </svg>
  );
}

TimecardSubmitIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
};
